module.exports = __webpack_public_path__ + "static/media/signed-pages-badge.d5eaa486.svg";